<template>
  <div class="add-fields-modal">
    <a-modal :centered="true" :title="`${formDisabled ? '查看' : (nowObj ? '编辑' : '')}分享`" :visible="visible"
      :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel" width="600px" okText="分享"
      wrapClassName="cont-share">
      <a-form-model ref="form" :disabled="formDisabled" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-tabs type="card" v-model="activeKey" class="page-tabs" @change="changeTab">
          <a-tab-pane key="internal" tab="内部用户"></a-tab-pane>
          <a-tab-pane key="external" tab="外部用户"></a-tab-pane>
          <!-- <a-tab-pane key="media" tab="Media"></a-tab-pane> -->
        </a-tabs>
        <template v-if="activeKey === 'internal'">
          <a-form-model-item label="个人" prop="name" :rules="[
            { validator: validatorRequired, trigger: 'change' },
          ]">
            <a-select v-model="form.name" style="width: 280px" mode="multiple" :filter-option="false"
              placeholder="请输入用户关键字进行搜索" @search="searchModel" @change="$refs.form.clearValidate('shareOrgId')">
              <a-select-option v-for="item in tableList" :key="item.loginName" :value="item.loginName">
                <div>{{ item.userName }} <span v-show="item.orgName"> - {{ item.orgName }}</span></div>
              </a-select-option>
            </a-select>
            <div class="form-check">
              <a-checkbox v-model="isShow" :disabled="true">查看</a-checkbox>
              <a-checkbox v-model="isEdit">编辑</a-checkbox>
            </div>
          </a-form-model-item>
          <a-form-model-item label="部门" prop="shareOrgId" :rules="[
            { validator: validatorRequired, trigger: 'change' },
          ]">
            <a-tree-select v-model="form.shareOrgId" style="width: 280px" allow-clear showSearch
              @change="$refs.form.clearValidate('name')"
              tree-node-filter-prop="title"
              :replaceFields="{ children: 'children', title: 'name', key: 'id', value: 'id' }"
              :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }" :tree-data="orgTree" placeholder="请选择部门信息">
            </a-tree-select>
            <div class="form-check">
              <a-checkbox v-model="isShow" :disabled="true">查看</a-checkbox>
            </div>
          </a-form-model-item>
          <div class="form-link">
            <div class="label">分享链接：</div>
            <!-- <div class="url">{{ templateShareUrl }}</div> -->
            <a class="url" :href="templateShareUrl">{{ templateShareUrl }}</a>
            <a-button type="primary" ghost size="small" @click="copyTemplateShareUrl">复制</a-button>
          </div>

        </template>
        <template v-else-if="activeKey === 'external'">
          <a-form-model-item label="用户名" prop="emails" :rules="[
            { required: true, message: '请填写邮箱，以逗号分隔', trigger: 'blur', },
            { validator: validatorEmails, trigger: 'blur', }
          ]">
            <a-input v-model="form.emails" placeholder="请填写邮箱，以逗号分隔"></a-input>
          </a-form-model-item>
        </template>
        <template v-else-if="activeKey === 'media'">
          <a-form-model-item label="财务ID" prop="name" :rules="[
            { required: true, message: '请选择财务ID', trigger: 'blur' },
          ]">
            <a-select v-model="form.name" :showSearch="true" :filter-option="false" placeholder="请输入财务ID关键字进行搜索"
              @search="searchFinanceList">
              <a-select-option v-for="item in financeList" :key="item.advertiserId" :value="item.corporationCode">
                <div>{{ item.advertiserId }} </div>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>
      </a-form-model>
      <div slot="footer" v-if="formDisabled"></div>
    </a-modal>
  </div>
</template>
<script>
import { addShare, getUserNames, getFinanceIdList } from "@/api/shareModal"
import { getOrgTreeApi } from "@/api/user"
// import matchFieldList from "./actionTypes"
const initForm = {
  name: [],
  emails: undefined,
  shareOrgId: undefined
}
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      formDisabled: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      activeKey: 'internal',
      form: this.$deepclone(initForm),
      tableList: [],
      financeList: [],
      nowObj: null,
      isShow: true,
      isEdit: false,
      orgTree: []
    };
  },
  computed: {
    templateShareUrl() {
      return `${location.origin}/modelViewer?reportCode=${this.record.analysisTemplateId}`
    }
  },
  props: {
    record: {
      type: Object,
      default: () => { }
    }
  },
  mounted() {
    this.getOrgTree();
  },
  methods: {
    searchModel(val) {
      this.fetchModel(val);
    },
    fetchModel(val) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getModelList(val);
      }, 500);
    },

    getModelList(userName) {
      this.loading = true
      getUserNames({
        userName
      }).then((res) => {
        this.tableList = this.$deepclone(res.data) || []
      }).finally(() => this.loading = false)
    },
    searchFinanceList(val) {
      this.fetchFinanceList(val);
    },
    fetchFinanceList(val) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getFinanceList(val);
      }, 500);
    },
    getFinanceList(searchKeyWord) {
      this.loading = true
      getFinanceIdList({
        searchKeyWord
      }).then((res) => {
        this.financeList = this.$deepclone(res.data) || []
      }).finally(() => this.loading = false)
    },

    validatorEmails(rule, value, callback) {
      if (!/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},*[\W]*)+$/.test(value)) {
        callback(new Error('请正确填写邮箱，以逗号分隔'))
      } else {
        callback()
      }
    },
    validatorRequired(rule, value, callback) {
      if (this.form.name.length > 0 || this.form.shareOrgId) {
        callback()
      } else {
        callback(new Error('请至少选一个分享对象'))
      }
    },

    getEmails(val) {
      if (val === 'internal') {
        return this.form.name;
      } else if (val === 'external') {
        return this.form.emails.split(",")
      } else if (val === 'media') {
        return [this.form.name]
      }
    },
    handleOk(e) {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(this.record)
          const params = {
            type: this.activeKey,
            templateId: this.record.analysisTemplateId,
            templateName: this.record.name,
            userEmails: this.getEmails(this.activeKey),
            permission: this.isEdit && this.activeKey === 'internal' ? 'w' : undefined,
            shareOrgId: this.form.shareOrgId
          };
          this.confirmLoading = true;
          // let api = this.nowObj ? updateChartSub : addShare;
          let api = addShare;
          api(params).then((res) => {
            if (this.activeKey === "internal") {
              gtag('event', 'internal_share_model', {
                modelName: this.record.name,
                userEmails: this.getEmails(this.activeKey),
              });
            } else {
              gtag('event', 'external_share_model', {
                modelName: this.record.name,
                userEmails: this.getEmails(this.activeKey),
              });
            }
            // console.log(first)
            this.$message.success(`${this.nowObj ? '编辑' : '分享'}成功！`)
            this.visible = false
            this.reset()
            this.$emit('success')
          }).finally(() => this.confirmLoading = false)
        } else {
          return false;
        }
      });
    },
    handleCancel(e) {
      this.reset()
      this.visible = false;
    },
    changeTab(value) {
      this.reset();
      if (value === 'media') {
        this.searchFinanceList('')
      }
    },
    reset() {
      this.form = this.$deepclone(initForm)
      this.$refs.form.clearValidate()
    },
    getOrgTree() {
      getOrgTreeApi().then(res => {
        this.orgTree = [res.data];
      })
    },
    copyTemplateShareUrl() {
      var ele = document.createElement("input");
      ele.value = this.templateShareUrl;
      document.body.appendChild(ele);
      ele.select();
      document.execCommand("copy");
      document.body.removeChild(ele);
      if (document.execCommand("copy")) {
        this.$message.success('复制成功！')
      } else {
        this.$message.success('复制失败！')
      }
    }
  },

};
</script>
<style lang="less" scoped>
/deep/ .cont-share .ant-modal-body {
  padding-top: 0;
}

.division-title {
  text-align: left;
  line-height: 40px;
  padding-right: 10px;
}

.delete-info {
  font-size: 16px;
  vertical-align: middle;
  margin-left: 10px;
}

.page-tabs {
  /deep/ .ant-tabs-bar {
    border-bottom: none;
  }
}

.form-check {
  display: inline-block;
  padding-left: 8px;
}

.form-link {
  display: flex;
  align-items: center;
  padding: 0 30px;
  padding-bottom: 20px;

  .label {}

  .url {
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 15px;
    color: rgba(66, 120, 255, 1);
  }

}
</style>